import { Layout, NotificationDetail } from '@/views/notifications';

export default {
    path: '/notifications',
    component: Layout,
    children: [
        { path: ':id', component: NotificationDetail },
    ]
};
